import { render, staticRenderFns } from "./PropertyGroupEditor.vue?vue&type=template&id=045e9b37&scoped=true&lang=pug&"
import script from "./PropertyGroupEditor.vue?vue&type=script&lang=ts&"
export * from "./PropertyGroupEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyGroupEditor.vue?vue&type=style&index=0&id=045e9b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e9b37",
  null
  
)

export default component.exports